import { render, staticRenderFns } from "./categoria_screen.vue?vue&type=template&id=571d561c"
import script from "./categoria_screen.vue?vue&type=script&lang=js"
export * from "./categoria_screen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports